import React from "react";
import ReactDOM from "react-dom";
import App from './App.jsx';

if (document.getElementById("react-area")) {
  ReactDOM.render(<App />, document.getElementById("react-area"));
}
